import moment from 'moment';
import some from 'lodash/some';


function EditForm($scope, weekService, activityLogService, timingStrategyService, durationService, CALCULATION_TYPE) {

    const updateDurationMinutes = () => {
        if (this.duration) {
            this.durationMinutes = this.converter.toMinutes(this.duration);
        }
        this.days.forEach(day => {
            day.durationMinutes = this.converter.toMinutes(day.duration);
        });
    };

    const setUserWorkingConfig = ({ userWorkingConfig }) => {
        this.userWorkingConfig = userWorkingConfig;
        this.converter = durationService.getConverter();
        this.formatter = durationService.getFormatter({ mode: 'hm' });
        this.dayFormatter = durationService.getFormatter({ mode: 'hm' });
    };

    const setCalculationTemplate = ({ endTime, userWorkingConfig, teamId, issueId, issueType, parentItemType, assignTo, availableUsers, priorityId, createdDate, sprintId, availableSprints, activityStatus, projectItemTypeConfigId}) => {
        this.loading = false;
        this.endTimeDay = endTime;
        this.endTimeHrs = endTime;
        this.teamId = teamId;
        this.issueId = issueId;
        this.issueType = issueType;
        this.parentItemType = parentItemType;
        this.duration = {};
        this.days = [];
        this.activityStatus = activityStatus;
        this.currentDay = moment().format();
        this.assignedTo = assignTo;
        this.availableUsers = availableUsers;
        this.priorityId = priorityId;
        this.createdDate = createdDate;
        this.selectedSprint = { id: sprintId };
        this.projectItemTypeConfigId = projectItemTypeConfigId;
        //this.startTimeMax = moment(endTime).toDate();
        this.endTimeMax = moment().toDate();
        this.setGlobalLock();
        setUserWorkingConfig({ userWorkingConfig });
        setSprints(availableSprints);
    };

    const setActivityLog = (activityLog) => {
        const { comment, isActive, teamId, issueId, issueType, parentItemType, activityStatus, assignedTo, isReadOnly, categoryId, sprintId, availableUsers, priorityId, createdDate, projectItemTypeConfigId } = activityLog;

        this.assignedTo = assignedTo;
        this.isActive = isActive;
        this.comment = comment;
        this.teamId = teamId;
        this.issueId = issueId;
        this.issueType = issueType;
        this.parentItemType = parentItemType;
        this.activityStatus = activityStatus;
        this.currentDay = moment().format();
        this.isReadOnly = isReadOnly;
        this.categoryId = categoryId;
        this.selectedSprint = { id: sprintId };
        this.availableUsers = availableUsers;
        this.priorityId = priorityId;
        this.createdDate = createdDate;
        this.projectItemTypeConfigId = projectItemTypeConfigId;
        setUserWorkingConfig(activityLog);
        updateActivityLog(activityLog);
    };

    const updateActivityLog = ({ durationMinutes, childDurationMinutes, activitySubItems, days, startTime, endTime, weeks, availableSprints, sprintId }, resetWeek = true) => {
        
       this.loading = false;
        this.currentDay = moment().format();
        this.duration = this.converter.fromMinutes(durationMinutes);
        this.childDuration = this.converter.fromMinutes(childDurationMinutes);
        this.startTime = startTime;
        this.endTime = endTime;

        this.startTimeDay = startTime;
        this.startTimeHrs = startTime;

        this.endTimeDay = endTime;
        this.endTimeHrs = endTime;
        this.selectedSprint = { id: sprintId };

        this.days = days;
        this.days.forEach(day => {
            day.duration = this.converter.fromMinutes(day.durationMinutes);
            day.childDuration = this.converter.fromMinutes(day.childDurationMinutes);
        });

        this.setGlobalLock();
        this.weeks = weekService.groupByWeek({ days, startTime, endTime });

        if (resetWeek) {
            this.currentWeekIndex = 0;
        }

        
        setSprints(availableSprints);
        this.showSprint = this.isProjectIterationBased;
        //this.startTimeMax = moment(endTime).toDate();
        //this.endTimeMin = moment(startTime).toDate();
        this.endTimeMax = moment().toDate();
        this.activitySubItems  = activitySubItems;
    };

    const setSprints = (availableSprints) =>
    {
        this.availableSprints = availableSprints;

        if (this.availableSprints) {
            if (this.selectedSprint) {
                var found = false;

                for (var i = 0; i < this.availableSprints.length; i++) {
                    if (this.availableSprints[i].id === this.selectedSprint.id) {
                        this.selectedSprint = this.availableSprints[i];
                        found = true;
                    }
                }

                if (!found) this.selectedSprint = this.availableSprints[0];
            }
            else this.selectedSprint = this.availableSprints[0];
        }
    }

    const getDataForCalculation = () => {
        updateDurationMinutes();
        return {
            calculationFor: this.calculationType,
            durationMinutes: this.durationMinutes,
            endTime: this.endTime,
            startTime: this.startTime,
            days: this.days,
            teamId: this.teamId,
            issueId: this.issueId,
            issueType: this.issueType,
            parentItemType: this.parentItemType,
            categoryId: this.categoryId,
            assignedTo: this.assignedTo,
            sprintId:  this.selectedSprint ? this.selectedSprint.id : null,
            activityStatus: this.activityStatus,
            priorityId: this.priorityId,
            createdDate: this.createdDate,
            userWorkingConfig: this.userWorkingConfig,
            projectItemTypeConfigId: this.projectItemTypeConfigId
        }
    }

    const getDayOnly = (someDate) => {
        return moment(someDate).format('YYYY-MM-DD');
    };

    const getHrsAndMinOnly = (someDate) => {
        return moment(someDate).format('HH:mm');
    };

        const readDateFromCalendar = () =>
        {
            if(this.startTimeDay)
            {
                this.startTime = moment(getDayOnly(this.startTimeDay) +' '+ getHrsAndMinOnly(this.startTimeHrs)).toDate();
            }
            if(this.endTimeDay)
            {
                this.endTime =moment(getDayOnly(this.endTimeDay) +' '+ getHrsAndMinOnly(this.endTimeHrs)).toDate();
            }
        }

    this.calculateForNewRange = (changed) => {

        readDateFromCalendar();

        if (!this.startTime || !this.endTime || some(this.days.map(d => d.duration), ['invalid', true])) {
            return;
        } 
        this.loading = true;
        this.calculationType = CALCULATION_TYPE.EDGES;

        if (changed === 'start' && moment(this.startTime).isAfter(this.endTime) ) {
            if(moment(this.startTime).isBefore(moment()))
            {
                this.calculationType = CALCULATION_TYPE.START_AND_DURATION;
            }
            else
            {
                this.endTime = moment();
                this.calculationType = CALCULATION_TYPE.END_AND_DURATION;
            }
        } else if (changed === 'end') {
            if(moment(this.endTime).isBefore(this.startTime))
            {
                this.calculationType = CALCULATION_TYPE.END_AND_DURATION;
            }
            else if(moment(this.endTime).isAfter(moment()))
            {
                this.endTime = moment();
                this.calculationType = CALCULATION_TYPE.EDGES;
            }
        }
        else if((this.activityLogId || this.durationWasChanged) && !this.isActive)
        {
            this.calculationType = CALCULATION_TYPE.EDGES_FOR_EXISTING_INTERVAL
        }


        timingStrategyService.calculate(this.activityLogId, getDataForCalculation())
            .then(updateActivityLog);
    };
    this.calculateForSprintUserChange = (changed) => {

        if (!this.startTime || !this.endTime || some(this.days.map(d => d.duration), ['invalid', true]))
        {
            return;
        }
        
        if(!this.calculationType)
        {   
            this.calculationType = CALCULATION_TYPE.EDGES;
        }
            
        timingStrategyService.calculate(this.activityLogId, getDataForCalculation())
                .then(updateActivityLog);

                
    };
    this.dayLockChange = () =>
    {
        this.setGlobalLock();
    }

    this.onGlobalLockChange = () =>
    {
        this.days.forEach(day => {
            day.isOverriden = !this.globalLock;
        });
        this.setGlobalLock();
    }

    this.setGlobalLock = () =>
    {
        this.globalLock =  this.days.every(
            (day )=> 
                {
                    return day.isOverriden
                }
        )
    }

    this.calculateForNewDay = () => {

        readDateFromCalendar();
        if (!this.startTime || !this.endTime || some(this.days.map(d => d.duration), ['invalid', true])) return;

        this.loading = true;
        this.calculationType = CALCULATION_TYPE.DAYS_OVERRIDE;
        timingStrategyService.calculate(this.activityLogId, getDataForCalculation())
            .then(model => {
                updateActivityLog(model, false);
            });
    };

    this.calculateForNewDuration = () => {
        readDateFromCalendar();

        if (!this.endTime || this.duration.invalid || some(this.days.map(d => d.duration), ['invalid', true])) return;

        this.loading = true;
        this.durationWasChanged = true;
        this.calculationType = CALCULATION_TYPE.END_AND_DURATION;
        if(this.startTime && this.endTime)
        {
            this.calculationType = CALCULATION_TYPE.DURATION_FOR_EXISTING_INTERVAL;
        }

        timingStrategyService.calculate(this.activityLogId, getDataForCalculation())
            .then(updateActivityLog);
    };

    this.$onInit = () => {

        this.daysOfWeek = weekService.getDaysOfWeek();

        this.assignedTo = 0;

        this.loading = true;

        if (this.creationMode) {
            this.showSprint = false;
            timingStrategyService.getCalculationTemplate(this.issueId, this.teamId)
                .then(setCalculationTemplate);
        } else {
            activityLogService.getActivityLog(this.activityLogId, this.teamId)
                .then(setActivityLog);
        }

        if (DEBUG) {
            console.log(this);
        }
        $('[data-toggle="tooltip"]').tooltip();
    };

    this.setCurrentWeek = (week) => {
        if (!$scope.editor.weekEditor.$invalid) {
            this.currentWeekIndex = week.index;
        }
    };

    this.save = () => {
        
        readDateFromCalendar();

        const callback = ({ id } = {}) => {
            let workLog = {
                id,
                startTime: this.startTime,
                endTime: this.endTime,
                comment: this.comment,
                duration: this.duration,
                childDuration: this.childDuration,
                userWorkingConfig: this.userWorkingConfig
            }
            if (this.onSaved) {
                this.onSaved({ $event: { workLog } });
                $scope.$emit('workLogChanged', this.issueId);
            };
        };

        updateDurationMinutes();
        activityLogService.upsetActivityLog(this)
            .then(({id, assignedTo }) => {
                let workLog = {
                    id: id,
                    startTime: this.startTime,
                    endTime: this.endTime,
                    comment: this.comment,
                    duration: this.duration,
                    userWorkingConfig: this.userWorkingConfig,
                    assignedTo: assignedTo,
                    activitySubItems: this.activitySubItems,
                    childDuration: this.childDuration
                }
                if (this.onSaved) {
                    this.onSaved({ $event: { workLog } });
                    $scope.$emit('workLogChanged', this.issueId);
                };
            });
    };

    this.cancel = () => {
        if (this.onCanceled)
            this.onCanceled();
    };
}
EditForm.$inject = ['$scope', 'weekService', 'activityLogService', 'timingStrategyService', 'durationService', 'CALCULATION_TYPE'];

module.exports = EditForm;


// WEBPACK FOOTER //
// ./components/work-log-editor/edit-form/edit-form.controller.js